module.exports = __webpack_public_path__ + "img/faired-multipoint-lock.56ca4c3.svg";